import { RIBBON_BANNER_HEIGHT } from "../screens/root/constants";

const filterList = {
  display: "flex",
  w: "full",
  py: "8px",
  justifyContent: "space-between",
  color: "dune.100",
};

const readerContainer = {
  // position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "black",
  zIndex: "auto",
};

const channelTab = {
  color: "white",
  fontWeight: 500,
  fontSize: "12px",
  lineHeight: "130%",
  whiteSpace: "nowrap",
};

const ribbonBanner = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: RIBBON_BANNER_HEIGHT + "px",
  gap: "20px",
  px: "16px",
};

const ribbonBannerCover = {
  display: "flex",
  borderTopRadius: "4px",
  border: ".5px solid rgba(255, 255, 255, 0.10)",
  borderBottom: "none",
  alignSelf: "flex-end",
};

const ribbonBannerCTA = {
  display: { base: "none", lg: "flex" },
};

export const layerStyles = {
  filterList,
  readerContainer,
  channelTab,
  ribbonBanner,
  ribbonBannerCover,
  ribbonBannerCTA,
};
